import { TextField, InputAdornment } from '@material-ui/core';
import NumberFormat from 'react-number-format';

const NumberFormatCustom = (props: any) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      onChange={() => { }}
      getInputRef={inputRef}
      decimalSeparator=","
      isNumericString
      onValueChange={values => {
        onChange({
          preventDefault: () => { },
          stopPropagation: () => { },
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

interface TextFieldProps {
  autoFocus?: boolean;
  autoComplete?: string;
  className?: string;
  color?: string;
  disabled?: boolean;
  error?: boolean;
  'data-parent'?: string;
  id?: string;
  label: string;
  mandatory?: boolean;
  multiline?: boolean;
  name?: string;
  helperText?: string;
  onChange?: (event: object) => void;
  onKeyUp?: (event: object) => void;
  onBlur?: () => void;
  onInput?: (event: object) => void;
  rows?: number;
  type?: React.InputHTMLAttributes<unknown>['type'];
  value?: string | number;
  placeholder?: string;
  variant?: 'filled' | 'outlined' | 'standard';
  endAdornment?: any;
  fullWidth?: boolean;
  readOnly?: boolean;
  important?: string;
}

export default class EdocatTextField extends window.React.PureComponent<TextFieldProps> {
  static defaultProps: TextFieldProps = {
    autoFocus: false,
    error: false,
    mandatory: false,
    className: '',
    label: '',
    rows: 1,
    variant: 'outlined',
    fullWidth: true,
  };

  render() {
    const {
      autoFocus,
      autoComplete,
      className,
      value,
      multiline,
      mandatory,
      label,
      error,
      id,
      onChange,
      onBlur,
      onKeyUp,
      onInput,
      name,
      disabled,
      type,
      rows,
      placeholder,
      variant,
      helperText,
      endAdornment,
      fullWidth,
      readOnly,
      important,
    } = this.props;

    return (
      <window.React.Fragment>
        <TextField
          autoComplete={autoComplete ?? "new-password"}
          autoFocus={autoFocus}
          className={className}
          disabled={disabled}
          error={!!error}
          helperText={
            error || important || helperText ? (
              <span className={`${important ? 'warning-message' : ''}`}>{error || important || helperText}</span>
            ) : null
          }
          id={id}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            'data-parent': this.props['data-parent'],
          }}
          InputProps={{
            endAdornment: endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : null,
            inputComponent: type === 'number' ? NumberFormatCustom : 'input',
            readOnly: readOnly,
            onInput: (event: React.ChangeEvent<HTMLInputElement>) => onInput && onInput(event),
          }}
          label={label}
          multiline={multiline}
          name={name}
          onChange={event => onChange && onChange(event)}
          onKeyUp={event => onKeyUp && onKeyUp(event)}
          onBlur={onBlur}
          required={mandatory}
          minRows={rows}
          type={type === 'number' ? 'text' : type}
          variant={variant}
          value={value}
          placeholder={placeholder}
          fullWidth={fullWidth}
        />
      </window.React.Fragment>
    );
  }
}
